import { FolderOpen } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function EmptyStateGuide({ module, message, ctaLabel, onCta }) {
  return (
    <div className="bg-white border border-[#E2E8F0] rounded-xl p-8 text-center" data-testid={`help-empty-${module}`}>
      <FolderOpen className="w-10 h-10 text-[#94A3B8] mx-auto mb-3" />
      <p className="text-sm text-[#64748B] mb-3">{message}</p>
      {ctaLabel && onCta && (
        <Button size="sm" onClick={onCta} data-testid={`help-empty-cta-${module}`}>{ctaLabel}</Button>
      )}
    </div>
  );
}
